import { api } from '../core';

interface UpdateChronologyEntryTimeResponse {
  success: boolean;
}

interface UpdateChronologyEntryTimeProps {
  abortController?: AbortController;
  entryId: string;
  time: string | null;
}

const chronologyEntryTimeUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntryTime: builder.query<UpdateChronologyEntryTimeResponse, UpdateChronologyEntryTimeProps>({
      query: ({ abortController = new AbortController(), entryId, time }: UpdateChronologyEntryTimeProps) => ({
        url: 'chronology/entry/time/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          time
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntryTime in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntryTimeQuery } = chronologyEntryTimeUpdateApi;
